import c from 'classnames';
import React, { useEffect, useState } from 'react';
import arrowSvg from './arrow_up.svg';
import './ScollButton.css';

const ScrollButton = () => {
    const [hidden, setHidden] = useState(true);

    const handleScroll = () => {
        window.scrollY === 0 ? setHidden(true) : setHidden(false);
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <button
            className={c('ScrollButton', { hidden })}
            onClick={() => window.scrollTo({ top: 0 })}
        >
            <img src={arrowSvg} alt="Arrow pointing up" />
            <span>Back to top</span>
        </button>
    );
};

export default ScrollButton;
